export const STORAGE_SELECTED_LANGUAGE = '@sotodocsSelectedLanguage';
export const STORAGE_ADD_NEW_CLIENT = '@sotodocsAddNewClient';
export const STORAGE_DOCUMENT_LAST_SORT_KEY = '@sotodocsDocumentsLastSortKey';
export const STORAGE_DOCUMENT_LAST_SORT_DIRECTION = '@sotodocsDocumentsLastSortDirection';
export const STORAGE_PDF_COPY_HELPER_ACTIVE = '@sotodocsPdfCopyHelperActive';
export const STORAGE_DOCUMENT_FIRST_UPLOAD_HINT = '@sotodocsFirstUploadHint';
